import { render, staticRenderFns } from "./simulated.vue?vue&type=template&id=cbc9564e"
import script from "./simulated.vue?vue&type=script&lang=js"
export * from "./simulated.vue?vue&type=script&lang=js"
import style0 from "./simulated.vue?vue&type=style&index=0&id=cbc9564e&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports